<script setup>
import { reactive } from 'vue';
import { Form } from 'vee-validate';
import FormInputCheckbox from '../fields/FormInputCheckbox.vue';
import * as yup from 'yup';
import { checkboxValidation } from '../utils/validations';

const emit = defineEmits(['advance-step']);

const props = defineProps({
    formData: {
        type: Object,
        required: true
    },
    insurer: {
        type: Object,
        required: true
    }
});

// Hydrate data when changing steps
const fields = reactive({
    acceptApplicationDeclaration: false,
    ...props.formData
});

const submit = (values) => {
    emit('advance-step', values);
};

const schema = yup.object({
    acceptApplicationDeclaration: checkboxValidation
});
</script>
<template>
    <Form :validation-schema="schema" @submit="submit">
        <h2 class="panel-heading h2">Application Declaration</h2>

        <div class="form-panel wysiwyg-output">
            <p>When completing my application I acknowledge the following:</p>

            <ul>
                <li>
                    I consent to the collection and use of my information being bound by
                    {{ props.insurer.name }} and Lifebroker’s privacy policies, which are available
                    at
                    <a class="tw-font-bold" target="_blank" :href="props.insurer.url">
                        {{ props.insurer.url }}
                    </a>
                    and
                    <a class="tw-font-bold" target="_blank" href="https://www.lifebroker.com.au/">
                        https://www.lifebroker.com.au/</a
                    >;
                </li>
                <li>
                    I consent to Lifebroker being appointed as the arranger of my Policy. By doing
                    this, I agree and understand that Lifebroker will have access to my policy
                    information, and will be able to give certain instructions to the insurer on my
                    behalf;
                </li>
                <li>
                    I have been sent the relevant
                    <a :href="props.insurer.pds" target="_blank">
                        Product Disclosure Statement (PDS)
                    </a>
                    for {{ props.insurer.name }}; and
                </li>
                <li>
                    I will review my application that {{ props.insurer.name }} will send to me, and
                    confirm that my answers will be accurate and complete. I will notify Lifebroker
                    as soon as possible if I need to make any changes.
                </li>
            </ul>

            <FormInputCheckbox
                class="tw-mt-6 sm:tw-mt-10"
                name="acceptApplicationDeclaration"
                :value="fields.acceptApplicationDeclaration"
                label="I, the Life Insured, accept the above Application declaration.*"
            />
        </div>

        <button class="btn btn--green btn--full">Next</button>
    </Form>
</template>
